import { render } from "./ForgotPasswordView2.vue?vue&type=template&id=2c8306c1&ts=true"
import script from "./ForgotPasswordView2.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView2.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__